import { TextField } from '@material-ui/core';
import { debounce } from 'lodash';
import { ChangeEvent, FC, useMemo, useState } from 'react';

import '../../../shared/CollectionHeaderBar/CollectionHeaderBar.scss';

const SEARCH_DELAY_MS = 400;

interface UserOrganizationsHeaderProps {
  isLoading?: boolean;
  isReloading?: boolean;
  onSearch: (searchText: string) => void;
  totalChecked: number;
  totalRecords: number;
}

const UserOrganizationsHeader: FC<UserOrganizationsHeaderProps> = ({
  isLoading,
  isReloading,
  onSearch,
  totalChecked,
  totalRecords,
}: UserOrganizationsHeaderProps) => {
  const [searchText, setSearchText] = useState('');
  const debouncedOnSearch = useMemo(
    () =>
      debounce((text: string) => {
        onSearch?.(text);
      }, SEARCH_DELAY_MS),
    [onSearch]
  );
  const handleSearchFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!debouncedOnSearch) return;
    setSearchText(event.target.value);
    debouncedOnSearch(event.target.value);
  };
  const isInALoadingState = isLoading || isReloading;
  const unitText = `${totalChecked} of ${totalRecords} checked`;
  const displayText = isInALoadingState ? 'Loading...' : unitText;
  return (
    <div className="CollectionHeaderBar">
      <div className="CollectionHeaderBar-text">{displayText}</div>
      <div className="CollectionHeaderBar-actions">
        <TextField
          variant="outlined"
          margin="dense"
          value={searchText}
          onChange={handleSearchFieldChange}
          placeholder="Search"
        />
      </div>
    </div>
  );
};

export default UserOrganizationsHeader;
